import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ReactComponent as ArrowdownSVG } from 'assets/icons/arrow-down.svg';
import { HintField, LabelField } from 'components';
import React, { useEffect, useRef, useState } from 'react';

const PaymentTypeSelect = ({
  formik,
  index,
  items,
  value,
  title,
  name,
  className,
  mandatory,
  titleStyle,
}) => {
  const [openTypeMenu, setOpenTypeMenu] = useState(false);

  const openLedgerMenuHandler = () => {
    setOpenTypeMenu(!openTypeMenu);
  };

  const menuRef = useRef();
  useEffect(() => {
    let handler = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setOpenTypeMenu(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    };
  });
  return (
    <>
      <LabelField
        htmlFor={name}
        title={title}
        labelClassName={className}
        mandatory={mandatory}
        style={titleStyle}
      />
      <div className="class_LedgersMenu">
        <button
          className="class_LedgersMenu_btn"
          onClick={openLedgerMenuHandler}
          ref={menuRef}
        >
          <div className="ledger_value">
  {value === "Optional" ? "Add-ons" : value}
          </div>
          <ul className="ledgers_ul">
            {openTypeMenu &&
              items?.length > 0 &&
              items?.map((item) => {
                return (
                  <li
                    className="ledgers_li"
                    key={item}
                    onClick={() => {
                      if (item === formik.values?.prices[index].type) return;
                      // Reset all type-specific fields when switching type
                      formik.setFieldValue(`prices[${index}].type`, item);
                      formik.setFieldValue(`prices[${index}].amount`, '');
                      formik.setFieldValue(`prices[${index}].minAmount`, '');
                      formik.setFieldValue(`prices[${index}].ledger`, {});
                      formik.setFieldValue(`prices[${index}].subLedger`, {});
                      formik.setFieldValue(`prices[${index}].required_notes`, undefined);
                      formik.setFieldValue(`prices[${index}].required`, false);
                      formik.setFieldValue(`prices[${index}].variant`, false);
                      formik.setFieldValue(`prices[${index}].infiniteQuantity`, true);
                      formik.setFieldValue(`prices[${index}].quantity`, '');
                      formik.setFieldValue(`prices[${index}].limitType`, 'amount');
                      formik.setFieldValue(`prices[${index}].tax_deductible`, '');
                      formik.setFieldValue(`prices[${index}].chargeDate`, '');
                      formik.setFieldValue(`prices[${index}].dueDate`, '');
                      formik.setFieldValue(`prices[${index}].is_splitted`, false);
                      formik.setFieldValue(`prices[${index}].split_duration`, undefined);
                      formik.setFieldValue(`prices[${index}].number_of_split`, undefined);
                      formik.setFieldValue(`prices[${index}].isInstallmentTransaction`, false);
                      formik.setFieldValue(`prices[${index}].installmentDetailsTransaction`, undefined);
                      formik.setFieldValue(`prices[${index}].variantInfo`, [{
                        name: '', quantity: '', infiniteQuantity: true, amount: '', reserveProduct: 0, forMemberOnly: false, openAmount: false,
                      }]);
                      // Type-specific defaults
                      if (item === 'Optional') {
                        formik.setFieldValue(`prices[${index}].limitType`, 'checkbox');
                      }
                    }}
                  >
                    {item === "Optional" ? "Add-ons" : item}
                  </li>
                );
              })}
          </ul>
          {openTypeMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </button>
      </div>
    </>
  );
};

export default PaymentTypeSelect;
